export default function getProductById(id, products = []) {
  if (id && products) return products.find(product => product.id === id)
  else return null
}
